import styled from "styled-components";
import { AsyncImage, AsyncImageAttributes, Attribute, AttributeGroup, AttributeGroupType, AttributeProperty, ButtonStateAttributes, ComponentProps, ConfigContext, ConfigsProvider, Container, ContainerAttributes, FontTheme, LinkButton, LinkButtonAttributes, ListBuilder, ListBuilderAttributes, Text, TextAttributes } from "react-builder";
import { createContext, useEffect, useState } from "react";
import { useProductApi } from "../../custom-hooks/useProductApi";

export interface IPricingPlan {
    "authAmount": 1,
    "regularInstallment": {
        "amount": 59.99,
        "totalInstallments": 36,
        "period": "DAY",
        "currency": "USD",
        "_id": "65d4ae4e665811b8564609d9"
    },
    "trialInstallment": {
        "amount": 9.99,
        "totalInstallments": 1,
        "period": "MONTH",
        "currency": "USD",
        "_id": "65d4ae4e665811b8564609da"
    },
    "_id": "676bfc84cc0858b36a669e2c",
    "title": "Plan 1",
    "subtitle": "3 Months MEMBERSHIP",
    "regulation": "Automatically Billed per month unless cancelled.",
    isTrial?: boolean
}

export const PricingPlanContext = createContext<IPricingPlan | undefined>(undefined);

export class PricingPlanAttributes extends Attribute {

    @AttributeProperty({ type: 'Object', cssTarget: '' })
    container: ContainerAttributes = new ContainerAttributes()

    @AttributeProperty({ type: 'Object', title: 'title' })
    title: TextAttributes = new TextAttributes();

    @AttributeProperty({ type: 'Object', title: 'subtitle' })
    subtitle: TextAttributes = new TextAttributes();

    @AttributeProperty({ type: 'Object', title: 'Featured container' })
    featureContainer: ContainerAttributes = new ContainerAttributes()

    @AttributeProperty({ title: 'List of features', type: AttributeGroupType.List, arrayType: 'string' })
    features: string[] = []

    @AttributeProperty({ type: 'Object', cssTarget: ' .feature', title: 'Featured font' })
    featureFont: FontTheme = new FontTheme();

    // @AttributeProperty({ type: 'Image', title: 'Featured Icon' })
    // featureIcon?: string;

    @AttributeProperty({ type: 'Object', title: 'Featured Icon' })
    featureIcon: AsyncImageAttributes = new AsyncImageAttributes()

    @AttributeProperty({ type: 'Object' })
    button: LinkButtonAttributes = new LinkButtonAttributes()

    @AttributeProperty({ type: 'Object', title: 'Regulation' })
    regulation: TextAttributes = new TextAttributes().fromJSON({ text: '{plan.regulation}' });
}

@AttributeGroup({ title: 'PricingPlansBuilder', blockName: 'PricingPlansBuilder', module: 'domain' })
export class PricingPlansProviderAttributes extends Attribute {

    @AttributeProperty({ type: 'Object', cssTarget: '' })
    container: ContainerAttributes = new ContainerAttributes()

    @AttributeProperty({ type: 'Object', cssTarget: " .regular" })
    regularPlan: PricingPlanAttributes = new PricingPlanAttributes()

    @AttributeProperty({ type: 'Object', cssTarget: " .trial" })
    trialPlan: PricingPlanAttributes = new PricingPlanAttributes()


}

const PricingPlansBuilderTheme = styled.div((props: { attributes: PricingPlansProviderAttributes }) => `

    ${props.attributes.toCSS()}

`);

let globalPlans: IPricingPlan[] = [];

function PricingPlansBuilder(props: ComponentProps<PricingPlansProviderAttributes>) {

    const API = useProductApi();
    const [plans, setPlans] = useState<IPricingPlan[]>(globalPlans);
    useEffect(() => {
        console.log('Pricing api...', API);

        // only once
        if (plans?.length > 0) return;

        API?.get('PricingPlans')
            .then((r: any) => {
                console.log(r);
                globalPlans = r;
                setPlans(r);
            })
    }, [API])

    return (
        <PricingPlansBuilderTheme {...props} attributes={props.attributes} >

            {plans.map((plan, j) => {
                const planProps = plan.isTrial ? props.attributes.trialPlan : props.attributes.regularPlan;
                return <ConfigsProvider configJson={{ plan }}>
                    <Container key={j} attributes={planProps.container} className={plan.isTrial ? 'trial' : 'regular'} >
                        <Text attributes={planProps.title} ></Text>
                        <Text attributes={planProps.subtitle} ></Text>

                        <Container attributes={planProps.featureContainer} >
                            {planProps.features.map((feature, i) => {

                                return <div key={i} style={{ display: 'flex', flexDirection: 'row' }} >
                                    <AsyncImage attributes={planProps.featureIcon} ></AsyncImage>
                                    <span className="feature"  >{feature}</span>
                                </div>
                            })

                            }
                        </Container>

                        <LinkButton attributes={planProps.button} ></LinkButton>

                        <Text attributes={planProps.regulation} ></Text>
                    </Container>
                </ConfigsProvider>
            })
            }

        </PricingPlansBuilderTheme >

    )
}


PricingPlansBuilder.prototype.Props = PricingPlansProviderAttributes;


export default PricingPlansBuilder;